import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import * as config from '../../home24/core/config';

export default Backbone.View.extend({
    /**
     *
     */
    constructor: function () {

        this.bindRivetsEventHandlers();

        Backbone.View.apply(this, arguments);
    },

    /*
     * Scroll window to new element
     */
    scrollToElement: function (options) {
        var $element = $(options.el);
        var topPosition = $element.offset().top;

        $('body, html').animate({
            scrollTop: topPosition - config.getInt('sliders.scrollFactor')
        }, 300, function () {
            if (options.callback && typeof options.callback === 'function') {
                options.callback();
            }
        });

    },

    /**
     *
     */
    bindRivetsEventHandlers: function () {
        if (_.isArray(this.rivetsEventHandlers)) {

            _.bindAll.apply(this, [].concat(this, this.rivetsEventHandlers));
        }
    },

    /**
     * destroy backbone view, unbind all events etc.
     */
    destroy: function () {
        this.undelegateEvents();
        this.$el.removeData().unbind();
        this.remove();
        Backbone.View.prototype.remove.call(this);
    }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/core/baseView.js
 **/